import React, {Fragment} from 'react';
import {Drawer, Empty} from "antd";
import './index.scss';
import SvgIcon from "../../../../components/svg-icon";
import {injectIntl} from 'react-intl'

const CouponDrawer = (props) => {
    const {data = {}, visible, receivePress, toggle, intl, currencySymbol} = props;
    const {canReceivedList = [], canUsedList = []} = data;
    return <Drawer
        width={290}
        className={'coupon-drawer'}
        visible={visible}
        title={intl.messages.YouHuiQuan || '优惠券'}
        onClose={toggle}
    >
        <Fragment>
            <div className={'coupon-drawer-title'}>{intl.messages.KLYHQ || '可领优惠券'}</div>
            {
                canReceivedList.length === 0 && <Empty/>
            }
            {
                canReceivedList.map(coupon => {
                    return <div className={'coupon-drawer-card'} key={coupon.id_}>
                        <div className={'detail-box'}>
                            <p className={'money'}>￥{coupon.money_}</p>
                            <p className={'name'}>{coupon.name_}</p>
                            <p className={'target'}>{
                                intl.formatMessage(
                                    {id: 'Man1YuanKeYong', defaultValue: ` 满${coupon.target_money_}可用`},
                                    {num: coupon.target_money_, currencySymbol: currencySymbol}
                                )
                            }</p>
                            <p className={'time'}>
                                {
                                    coupon.validity_type_ === 1 ?
                                        `${coupon.begin_time_} - ${coupon.end_time_}` :
                                        intl.formatMessage(
                                            {id: 'LQH1TNKY', defaultValue: `领券后${coupon.validity_day_}天内可用`},
                                            {day: coupon.validity_day_}
                                        )
                                }
                            </p>
                        </div>
                        <div className={'receive-btn'} role={'none'} onClick={() => receivePress(coupon)}>{intl.messages['LiJiLingQu'] || '立即领取'}</div>
                    </div>
                })
            }

        </Fragment>
        <Fragment>
            <div className={'coupon-drawer-title'}>{intl.messages.YLYH || '已领优惠'} <span className={'tips'}>（{intl.messages.MZTJJKSY || '满足条件即可使用'}）</span></div>
            {
                canUsedList.length === 0 && <Empty/>
            }
            {
                canUsedList.map(coupon => {
                    return <div className={'coupon-drawer-card'} key={coupon.id_}>
                        <div className={'detail-box'}>
                            <p className={'money'}>￥{coupon.money_}</p>
                            <p className={'name'}>{coupon.name_}</p>
                            <p className={'target'}>
                                {
                                    intl.formatMessage(
                                        {id: 'Man1YuanKeYong', defaultValue: ` 满${coupon.target_money_}可用`},
                                        {num: coupon.target_money_, currencySymbol: currencySymbol}
                                    )
                                }
                            </p>
                            <p className={'time'}>
                                {
                                    coupon.validity_type_ === 1 ?
                                        `${coupon.begin_time_} - ${coupon.end_time_}` :
                                        intl.formatMessage(
                                            {id: 'LQH1TNKY', defaultValue: `领券后${coupon.validity_day_}天内可用`},
                                            {day: coupon.validity_day_}
                                        )
                                }
                            </p>
                            <SvgIcon href={'icon-discount-coupon-get-48px'} className={'status-icon'}/>
                        </div>
                    </div>
                })
            }

        </Fragment>
    </Drawer>
};
export default injectIntl(CouponDrawer);
